import { render, staticRenderFns } from "./logsModal.vue?vue&type=template&id=48cf4369&scoped=true&"
import script from "./logsModal.vue?vue&type=script&lang=ts&"
export * from "./logsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48cf4369",
  null
  
)

export default component.exports